// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__gEIod","searchInput":"SearchBar_searchInput__6ZXoI"};